module.exports = __webpack_public_path__ + "static/media/Dual_3152.a51bf4fa.jpg";